import { useNavigate } from "react-router-dom";
import { FormSignupControllerImpl } from "../..";
import { ISubmitStrategy } from "../../../core/strategies/CodeValidateStrategy";

export class SignupCodeValidateStrategy implements ISubmitStrategy {
    private controller = new FormSignupControllerImpl();
    private navigate: ReturnType<typeof useNavigate>;
    private translate: any;

    constructor(navigate: ReturnType<typeof useNavigate>, translate: any) {
        this.navigate = navigate;
        this.translate = translate;
    }

    async execute(formData: FormData): Promise<void> {
        const response = await this.controller.signupCodeValidate(formData);
        if (response.success) {
            localStorage.setItem(
                'global-toast',
                JSON.stringify({ type: 'success', message: this.translate('signupSuccess') })
            );
            this.navigate('/auth', { state: { reload: true } });
        } else {
            throw new Error(response?.error);
        }
    }
}